import * as React from 'react'
import type { EventTicketType } from '@/components/events/event-ticket-types'

export function useTicketTypeFormState(ticket?: EventTicketType) {
  const basics = ticketTypeBasics(ticket)
  const audienceDefaults = ticketTypeAudienceDefaults(ticket)
  const [name, setName] = React.useState(basics.name)
  const [description, setDescription] = React.useState(basics.description)
  const [price, setPrice] = React.useState(basics.price)
  const [salesOpensOn, setSalesOpensOn] = React.useState(basics.salesOpensOn)
  const [salesClosesOn, setSalesClosesOn] = React.useState(basics.salesClosesOn)
  const [maxPerOrder, setMaxPerOrder] = React.useState(basics.maxPerOrder)
  const [capacity, setCapacity] = React.useState(basics.capacity)
  const [audience, setAudience] = React.useState(audienceDefaults.audience)
  const [membershipLevelIds, setMembershipLevelIds] = React.useState(
    audienceDefaults.membershipLevelIds,
  )
  const [taxRateId, setTaxRateId] = React.useState(
    ticket?.tax_rate ? String(ticket.tax_rate.id) : '',
  )
  const idempotencyKey = React.useRef(crypto.randomUUID())

  return {
    audience,
    capacity,
    description,
    idempotencyKey,
    maxPerOrder,
    membershipLevelIds,
    name,
    price,
    salesClosesOn,
    salesOpensOn,
    setAudience,
    setCapacity,
    setDescription,
    setMaxPerOrder,
    setMembershipLevelIds,
    setName,
    setPrice,
    setSalesClosesOn,
    setSalesOpensOn,
    setTaxRateId,
    taxRateId,
  }
}

function ticketTypeBasics(ticket?: EventTicketType) {
  return ticket ? ticketTypeBasicsFor(ticket) : emptyTicketTypeBasics()
}

function ticketTypeBasicsFor(ticket: EventTicketType) {
  return {
    capacity: ticket.capacity?.toString() ?? '',
    description: ticket.description ?? '',
    maxPerOrder: ticket.max_per_order?.toString() ?? '',
    name: ticket.name,
    price: (ticket.price_cents / 100).toFixed(2),
    salesClosesOn: ticket.sales_closes_on ?? '',
    salesOpensOn: ticket.sales_opens_on ?? '',
  }
}

function emptyTicketTypeBasics() {
  return {
    capacity: '',
    description: '',
    maxPerOrder: '',
    name: '',
    price: '0.00',
    salesClosesOn: '',
    salesOpensOn: '',
  }
}

function ticketTypeAudienceDefaults(ticket?: EventTicketType) {
  return {
    audience: ticket?.audience ?? 'everyone',
    membershipLevelIds: ticket?.membership_levels?.map(({ id }) => id) ?? [],
  }
}
